module.exports = __webpack_public_path__ + "static/media/deswollenaer.1961d5a2.png";